import React, { useState, useMemo, useEffect } from 'react';
import * as Yup from 'yup';
import {
    CrudMasterDetailView,
    GridView,
    Widget,
    FormInput,
    FormSubmitButton,
    FormSelect,
    CompositeView,
    MasterDetailForm,
    FormatText,
    FormTextArea,
    ButtonDelete,
    CrudContext,
    useRouter,
    Button,
} from '@digital/ui';
import { hasPermission } from '../../helpers/permissions';
import { CreatModuloPerfil, creatModuloPerfilPermissao, deleteModuloPerfilPermissao, getAllModuloPerfilPermissao, updateModuloPerfilPermissao } from '@app/api/moduloPerfilPermissao';
import TabelaTipoModulo from './tabelaTipoModulo';
import ModalPermissoes from './modalPermissoes';
import { GuidEmpty } from '@app/helpers/generatorGuid';



const ModuloPerfilPermissao = () => {

    const [listModuloPerfilPermissao, setModuloPerfilPermissao] = useState(() => getAllModuloPerfilPermissao);

    const onCreatModulo = (values: CreatModuloPerfil) => {
        return creatModuloPerfilPermissao(values);
    }

    const onUpdateModulo = async (values: CreatModuloPerfil) => {
        const result = await updateModuloPerfilPermissao(values)
        if (result)
            listPermissaoEPerfil();

        return true;
    }

    const deleteModulo = (id: string) => {
        return deleteModuloPerfilPermissao(id).then(() => { listPermissaoEPerfil() });
    }

    const listPermissaoEPerfil = () => {
        setModuloPerfilPermissao(() => Promise.resolve(undefined));
        setModuloPerfilPermissao(() => getAllModuloPerfilPermissao);
    };

    const atualizarTabelaPermissoes = () => {
        listPermissaoEPerfil();
    }

    return (
        <CrudMasterDetailView
            getAllItems={listModuloPerfilPermissao}
            createItem={onCreatModulo}
            updateItem={onUpdateModulo}
            disableNotification
            icon="business-flow_chart"
            detailTitleExtractor={x => `${x.nome} - ${x.descricao}`}
            filterPredicate={(item, value) =>
                item.nome.toLowerCase().includes(value.toLowerCase())
            }
            titleExtractor={item => item.nome}
            descriptionExtractor={item => item.nome || `--- - ${item.descricao}`} >
            <CompositeView>
                {true && (
                    <CrudContext.Consumer>
                        {({ selectedItem }) => {
                            return (
                                <GridView noform>
                                    <MasterDetailForm
                                        validationSchema={() => {

                                        }}>
                                        <Widget
                                            actions={[
                                                selectedItem && true && (
                                                    <ButtonDelete
                                                        type="link"
                                                        confirm="Deseja realmente excluir este registro?"
                                                        okText="Confirmar"
                                                        onClick={
                                                            () => {
                                                                deleteModulo(selectedItem.id)
                                                            }
                                                        }
                                                    />
                                                ),
                                                true && (
                                                    <FormSubmitButton type="primary">
                                                        <FormatText id="ui.commons.save" uppercase />
                                                    </FormSubmitButton>
                                                ),
                                            ]}>
                                            <FormInput label="Nome" name="nome" span={6} />
                                            <FormTextArea label="Descrição" name="descricao" rows={3} />
                                        </Widget>

                                        {selectedItem && selectedItem.id != GuidEmpty && selectedItem.tipo && selectedItem.tipo.length > 0 ?
                                            (
                                                <>
                                                    {selectedItem.tipo.map((item: any) => {
                                                        return (
                                                            <Widget
                                                                title={item.nome}
                                                                actions={[
                                                                    <ModalPermissoes
                                                                        tipoModuloId={item.id}
                                                                        moduloId={selectedItem.id}
                                                                        atualizarTabelaPermissoes={atualizarTabelaPermissoes}
                                                                    />]
                                                                }>

                                                                <TabelaTipoModulo
                                                                    moduloId={selectedItem.id}
                                                                    tipoModuloPerfilPermissao={item}
                                                                    permissoes={item.permissoes}
                                                                    atualizarGrid={atualizarTabelaPermissoes}
                                                                />
                                                            </Widget>
                                                        )
                                                    })}
                                                </>
                                            ) :
                                            (
                                                <> </>
                                            )
                                        }

                                    </MasterDetailForm>
                                </GridView>
                            );
                        }}
                    </CrudContext.Consumer>
                )}
            </CompositeView>
        </CrudMasterDetailView >
    )

}

export default ModuloPerfilPermissao;